
import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import SidebarNavigation from './SidebarNavigation';
import SidebarUserProfile from './SidebarUserProfile';
import { User } from '@supabase/supabase-js';

interface SidebarProps {
  user: User | null;
  isMobile: boolean;
  isSidebarOpen: boolean;
  onCloseSidebar: () => void;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ 
  user,
  isMobile, 
  isSidebarOpen, 
  onCloseSidebar,
  onLogout
}) => {
  return (
    <aside 
      className={cn(
        "fixed inset-y-0 left-0 z-50 w-64 bg-card border-r border-border transform transition-all duration-300 ease-in-out flex flex-col",
        isMobile && !isSidebarOpen && "-translate-x-full",
        isMobile && isSidebarOpen && "translate-x-0",
        !isMobile && !isSidebarOpen && "-translate-x-48",
        !isMobile && isSidebarOpen && "translate-x-0",
        "md:sticky md:top-0 md:h-screen md:transform-none"
      )}
    >
      <div className="flex flex-col h-full">
        {/* Sidebar Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <Link to="/" className="flex items-center">
            <img 
              src="/lovable-uploads/15842cb5-3179-4432-90aa-2bb07c58715c.png" 
              alt="Site Logo" 
              className="h-auto w-25" 
              style={{ width: '25px' }}
            />
          </Link>
          {isMobile && (
            <Button 
              variant="ghost" 
              size="icon"
              onClick={onCloseSidebar}
            >
              <X className="h-5 w-5" />
            </Button>
          )}
        </div>

        {/* Navigation */}
        <SidebarNavigation isSidebarOpen={isSidebarOpen} />

        {/* User Profile */}
        <SidebarUserProfile 
          user={user}
          isSidebarOpen={isSidebarOpen}
          onLogout={onLogout}
        />
      </div>
    </aside>
  );
};

export default Sidebar;
